import { Button, Card, CardBody, CardHeader, Divider } from "@nextui-org/react";
import RootAdmin from "../../../../components/layouts/RootAdmin";
import { PlusIcon } from "@heroicons/react/24/outline";
import { useMemo, useState, useCallback } from "react";
import useSWR from "swr";
import { getFetcher } from "../../../../services/api";
import ClientDataGrid from "../../../../components/elements/ClientDataGrid";

export default function IndexPage() {
  const [searchQuery, setSearchQuery] = useState("");
  // State ini digunakan untuk men-trigger API hanya ketika tombol ditekann
  const [submittedSearch, setSubmittedSearch] = useState("");

  // API dipanggil bersyarat. Jika 'submittedSearch' kosong, nilai url-nya null (SWR tidak akan menembak API)
  const { data, isLoading } = useSWR(
    submittedSearch ? `/api/registrasi/validasi-b3/search?search_number=${submittedSearch}` : null,
    getFetcher
  );

  const handleSearchChange = useCallback((event) => {
    setSearchQuery(event.target.value);
  }, []);

  const handleSearchSubmit = () => {
    setSubmittedSearch(searchQuery);
  };

  // Menyiapkan baris data untuk ClientDataGrid
  const rows = useMemo(() => {
    // Menyesuaikan dengan format return SWR (terkadang dibungkus properti .data, terkadang langsung array)
    const rawData = Array.isArray(data) ? data : data?.data || [];
    
    // ClientDataGrid (MUI) wajib memiliki properti 'id' unik di setiap objeknya.
    // Karena API Anda tidak mengeluarkan 'id', kita buat on-the-fly menggunakan 'no_reg_bahan'
    return rawData.map((item, index) => ({
      ...item,
      id: item.no_reg_bahan || index, 
    }));
  }, [data]);

  // Menyesuaikan Header/Kolom Tabel dengan output JSON dari API baru
  const columns = useMemo(
    () => [
      { field: "nama_perusahaan", headerName: "Nama Perusahaan", flex: 1, minWidth: 250 },
      { field: "nomor_surat", headerName: "Nomor Surat", flex: 1, minWidth: 200 },
      { field: "cas_number", headerName: "CAS Number", width: 120 },
      { field: "nama_bahan", headerName: "Nama Bahan", flex: 1, minWidth: 150 },
      { field: "no_reg_bahan", headerName: "No. Reg Bahan", flex: 1, minWidth: 220 },
    ],
    []
  );

  return (
    <RootAdmin>
      <Card className="w-full mt-3" radius="sm">
        <CardHeader>
          <p className="text-md">Pencarian Nomor Registrasi B3</p>
        </CardHeader>
        <Divider />
        <CardBody className="w-full h-[550px] p-5">
          <div className="mb-5" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <SearchField 
              value={searchQuery} 
              onChange={handleSearchChange} 
              onEnter={handleSearchSubmit}
              placeholder="Masukkan CAS Number..." 
            />
            <Button 
              onPress={handleSearchSubmit} 
              size="md" 
              color="primary" 
              startContent={<PlusIcon className="size-4 stroke-2" />}
            >
              Cari Nomor Registrasi
            </Button>
          </div>
          
          <ClientDataGrid
            rows={rows}
            rowCount={rows.length}
            isLoading={isLoading}
            columns={columns}
            autoResize={false}
            initialState={{
              sorting: {
                sortModel: [{ field: "nama_perusahaan", sort: "asc" }],
              },
            }}
          />
        </CardBody>
      </Card>
    </RootAdmin>
  );
}

function SearchField({ value, onChange, onEnter, placeholder }) {
  return (  
    <div className="flex w-full items-center">
      <div className="w-full sm:w-1/4">
        <input
          type="text"
          id="search"
          value={value}
          onChange={onChange}
          onKeyDown={(e) => {
            // Tambahan UX: User bisa langsung menekan tombol Enter di keyboard untuk mencari
            if (e.key === 'Enter') {
              onEnter();
            }
          }}
          placeholder={placeholder}
          className="w-full px-3 py-2 border border-line-strong rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        />
      </div>
    </div>
  );
}
